<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image1" /> -->
    <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>
<div class="opacity-select-card card py-2 mt-6" style="width: 80%; margin: 0 auto 80px auto ; ">
    <transition
      appear
      @before-enter="$animations.beforeEnterAbove"
      @enter="$animations.enterAbove"
    >
      <Welcome></Welcome>
    </transition>

    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <div class="column is-half pt-5 ps-5">
            <div class="columns is-centered">
              <transition-group
                appear
                tag="div"
                @before-enter="$animations.beforeEnterStaggering"
                @enter="$animations.enterStaggering"
                style="display: contents"
              >
                <div
                  class="column is-half has-text-centered"
                  :key="1"
                  :data-index="1"
                >
                  <div
                    class="box id_box has-text-centered id-proof-button"
                    id="Id"
                    @click="selectIdProof(`ID`)"
                  >
                    <img
                      src="../assets/images/icons/socialMediaIcons/nic.png"
                      alt="nic image"
                      width="60%"
                    />
                  </div>
                  <b-field>
                    <ValidationProvider
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                    >
                      <b-radio
                        style="font-family: OpenSans-Regular"
                        native-value="ID"
                        @focus="$inputFocused('idProofType')"
                        @change="$inputChanged('idProofType')"
                        @blur="$inputBlured('idProofType')"
                        v-model="$root.formData.idProofType"
                        @click.native="
                          () => {
                            selectIdProof(`ID`);
                            resetProofNumber();
                          }
                        "
                      >
                        {{ $root.selectedLanguageData.nic }} </b-radio
                      ><span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider></b-field
                  >
                </div>
                <div
                  class="column is-half has-text-centered"
                  :key="2"
                  :data-index="2"
                >
                  <div
                    class="box id_box has-text-centered id-proof-button"
                    id="Pno"
                    @click="selectIdProof(`PNO`)"
                  >
                    <img
                      src="../assets/images/icons/socialMediaIcons/passport.png"
                      alt="nic image"
                      width="45%"
                    />
                  </div>
                  <b-field>
                    <ValidationProvider
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                    >
                      <b-radio
                        style="font-family: OpenSans-Regular"
                        native-value="PNO"
                        @focus="$inputFocused('idProofType')"
                        @input.native="$inputChanged('idProofType')"
                        @blur="$inputBlured('idProofType')"
                        v-model="$root.formData.idProofType"
                        @click.native="
                          () => {
                            selectIdProof(`PNO`);
                            resetProofNumber();
                          }
                        "
                      >
                        {{ $root.selectedLanguageData.passport }} </b-radio
                      ><span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider></b-field
                  >
                </div>
              </transition-group>
            </div>
          </div>
        </div>

        <transition-group
          appear
          tag="div"
          name="form-items"
          @before-enter="$animations.beforeEnterAbove"
          @enter="$animations.enterAbove"
          style="display: contents"
        >
          <div v-if="$root.formData.idProofType" :key="1">
            <div class="columns is-centered">
              <div class="column is-half">
                <div class="mt-2">
                  <div
                    v-if="
                      $root.formData.idProofType === `PNO` &&
                      $root.kycFieldVisibility.customer_passport_no
                    "
                  >
                    <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                    >
                      {{ $root.selectedLanguageData.passportProof
                      }}<span class="has-text-danger">*</span></label
                    >
                    <b-field>
                      <p class="control has-icons-right">
                        <ValidationProvider
                          :rules="passportValidateObject()"
                          v-slot="{ errors }"
                        >
                          <b-input
                            type="text"
                     
                            @focus="$inputFocused('customer_passport_no')"
                            @input="$inputChanged('customer_passport_no')"
                            @blur="$inputBlured('customer_passport_no')"
                            v-model="$root.formData.customer_passport_no"
                          />
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </p>
                    </b-field>
                  </div>
                  <div
                    v-if="
                      $root.formData.idProofType !== `PNO` &&
                      $root.kycFieldVisibility.customer_nic
                    "
                  >
                    <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                    >
                      {{ $root.selectedLanguageData.identityProofEnter
                      }}<span class="has-text-danger">*</span></label
                    >
                    <b-field>
                      <p class="control has-icons-right">
                        <ValidationProvider
                          :rules="{
                            required: true,
                            multiRegex: [/^([0-9]{9}[Xx||Vv])$/, /^[0-9]{12}$/],
                          }"
                          v-slot="{ errors }"
                        >
                          <b-input
                            type="text"
                          
                            @focus="$inputFocused('customer_nic')"
                            @input="$inputChanged('customer_nic')"
                            @blur="$inputBlured('customer_nic')"
                            v-model="$root.formData.customer_nic"
                          />
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </p>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="columns is-centered">
            <div class="column is-half">
              <b-field>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-checkbox
                    native-value="DRP"
                    disabled
                    v-model="$root.formData.nicNumberAllowToDRP"
                  ></b-checkbox>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <div v-show="!showFlag">
                  <p
                    :class="` ${
                      $root.selectedLanguage === `ta`
                        ? `tamil-content`
                        : $root.selectedLanguage === `si`
                        ? `sinhala-content`
                        : ``
                    }`"
                  >
                    {{ $root.selectedLanguageData.drp
                    }}<span class="has-text-danger"> * </span>

                    <span @click="showFlag = true" class="showcontant">{{
                      $root.selectedLanguageData.readMore
                    }}</span>
                  </p>
                </div>
                <div v-show="showFlag">
                  <p>
                    {{ $root.selectedLanguageData.drpShowContant }}
                    <span @click="showFlag = false" class="showcontant">{{
                      $root.selectedLanguageData.shoeLess
                    }}</span>
                  </p>
                </div>
              </b-field>
            </div>
          </div> -->
            <div class="columns is-centered">
              <div class="column is-half">
                <b-field>
                  <b-checkbox
                    native-value="Allow Location Services"
                    @focus="
                      $inputFocused(
                        'nicNumberAllowToLocationServicesInYourBrowser'
                      )
                    "
                    @input="
                      $inputChanged(
                        'nicNumberAllowToLocationServicesInYourBrowser'
                      )
                    "
                    @blur="
                      $inputBlured(
                        'nicNumberAllowToLocationServicesInYourBrowser'
                      )
                    "
                    v-model="
                      $root.formData
                        .nicNumberAllowToLocationServicesInYourBrowser
                    "
                  >
                  </b-checkbox>

                  <div v-show="!flagshow">
                    <p>
                      {{
                        $root.selectedLanguageData
                          .allowLocationServicesInYourBrowser
                      }}

                      <span @click="flagshow = true" class="showcontant">{{
                        $root.selectedLanguageData.readMore
                      }}</span>
                    </p>
                  </div>
                  <div v-show="flagshow">
                    <div>
                      <p>
                        {{
                          $root.selectedLanguageData
                            .allowLocationServicesInYourBrowserShowContant_1
                        }}
                      </p>
                      <p class="mt-3">
                        {{
                          $root.selectedLanguageData
                            .allowLocationServicesInYourBrowserShowContant_2
                        }}
                        <span @click="flagshow = false" class="showcontant">{{
                          $root.selectedLanguageData.shoeLess
                        }}</span>
                      </p>
                    </div>
                  </div>
                </b-field>
              </div>
            </div>
          </div>

          <div class="columns" :key="2">
            <div
              class="column is-6 is-offset-3 is-flex is-flex-direction-row-reverse"
            >
              <b-button
                :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                :disabled="invalid"
                :loading="continueButtonIsLoading"
                @click="verifyNicExist()"
                >{{ $root.selectedLanguageData.continue }}</b-button
              >
              <b-button
                :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"
                @click="$router.go(-1)"
                >{{ $root.selectedLanguageData.back }}</b-button
              >
            </div>
          </div>
        </transition-group>
      </form>
    </ValidationObserver>
  </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import "../validate.js";
import GetHelp from "./GetHelp.vue";
import Welcome from "./WelcomeForm.vue";
import Logo from "./NsbKycLogo.vue";
export default {
  components: {
    Welcome,
    GetHelp,
    Logo,
  },
  data() {
    return {
      showFlag: false,
      flagshow: false,
      continueButtonIsLoading: false,
      regex: {
        old_nic: /^([0-9]{9}[Xx||Vv])$/,
        passport: /^[0-9A-Za-z]{4,18}$/,
        new_nic: /[0-9]{12}/,
      },
    };
  },
  methods: {
    passportValidateObject() {
      let obj = {
        required: true,
        notMatchRegex: [this.regex.old_nic, this.regex.new_nic],
        regex: this.regex.passport,
      };
      return obj;
    },
    nicValidateObject: function () {
      const comp = this;
      let obj = {
        required: true,
      };

      if (comp.$root.formData.idType === "ONIC") {
        obj.regex = comp.regex.old_nic;
      } else if (comp.$root.formData.idType === "NNIC") {
        obj.regex = comp.regex.new_nic;
      }
      return obj;
    },
    selectIdProof(Idproof) {
      const IdElement = document.getElementById("Id");
      const PnoElement = document.getElementById("Pno");
      if (Idproof === `ID`) {
        IdElement.classList.add("id-proof-button-bg");
        PnoElement.classList.remove("id-proof-button-bg");
        this.$root.formData.idProofType = "ID";
      } else if (Idproof === `PNO`) {
        IdElement.classList.remove("id-proof-button-bg");
        PnoElement.classList.add("id-proof-button-bg");
        this.$root.formData.idProofType = "PNO";
      }
    },
    splitNic() {
      if (this.$root.formData.idProofType === `ID`) {
        if (this.$root.formData.customer_nic.length === 10) {
          this.$root.formData.idType = "ONIC";
        } else {
          this.$root.formData.idType = "NNIC";
        }
      } else {
        this.$root.formData.idType = "PNO";
      }
    },

    // method to navigate to the next page
    navigateToNextPage() {
      console.log("identification Type   : " + this.$root.formData.idType);
      console.log("nic Number : " + this.$root.formData.customer_nic);
      console.log(
        "Passport Number : " + this.$root.formData.customer_passport_no
      );

      this.$router.push("contact-info"); // original path
      // this.$router.push('documents_id')
      // this.$router.push('Document_Passport')
    },

    /* ---------------------------------------------------
      method to verify if the nic exist
    */
    verifyNicExist() {
      this.splitNic();
      var nicExist = false; // initially set as not exist

      this.splitNic();

      this.continueButtonIsLoading = true;

      window.element = this;

      var identificationType = "";
      var identificationNumber = "";

      // finding identification type
      if (this.$root.formData.idType === "ONIC") {
        identificationType = "old-nic";
      } else if (this.$root.formData.idType === "NNIC") {
        identificationType = "new-nic";
      } else if (this.$root.formData.idType === "PNO") {
        identificationType = "passport";
      }

      // finding relavent identification number
      if (this.$root.formData.idType === "PNO") {
        identificationNumber =
          this.$root.formData.customer_passport_no.toUpperCase();
      } else {
        identificationNumber = this.$root.formData.customer_nic;
      }

      try {
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/kycForm/verifyNicExists", {
            nicNumber: identificationNumber,
            nicType: identificationType,
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            console.log(response);

            // enable continue button after the response
            this.continueButtonIsLoading = false;

            if (response.data.success) {
              console.log("verify nic success------------------");
              console.log(response.data.data);

              nicExist = response.data.data.exists;

              if (nicExist) {
                // if entered nic is existed

                var message = "";

                if (this.$root.formData.idType === "PNO") {
                  message = "Entered passport number already exist!";
                } else {
                  message = "Entered NIC number already exist!";
                }
                this.$buefy.toast.open({
                  message: message,
                  type: "is-primary",
                });
              } else {
                // if nis is not exist
                this.getLocationFromBrowser();
              }
            } else {
              console.log("verify nic failed------------------");
              console.log(response.data);

              this.$buefy.toast.open({
                message: "Failed to verify NIC/Passport",
                type: "is-danger",
              });
            }
          });
      } catch (e) {
        console.log(
          "Exception occurred in EnterNIC - VerifyNicExist() ------------------"
        );
        console.log(e.message);

        this.$buefy.toast.open({
          message: "Failed to verify NIC/Passport",
          type: "is-danger",
        });

        // remove loading state from the continue button
        this.continueButtonIsLoading = false;
      }
    },
    resetProofNumber() {
      this.$root.formData.customer_passport_no = "";
      this.$root.formData.customer_nic = "";
    },
    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step: 2,
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    getLocationFromBrowser() {
      try {
        var comp = this;
        navigator.geolocation.getCurrentPosition(function (pos) {
          comp.$root.formData.location_details.form_submitted = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          };

          console.log(pos.coords);
          console.log(comp.$root.formData.location_details);

          if (comp.$root.formData.location_details.form_submitted != null) {
            if (
              comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser
                .length > 0
            ) {
              comp.$root.formData.locationAccess =
                comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser;
            } else {
              comp.$root.formData.locationAccess = "";
            }

            if (comp.$root.formData.nicNumberAllowToDRP.length > 0) {
              comp.$root.formData.nicVerificationDRP =
                comp.$root.formData.nicNumberAllowToDRP[0];
            } else {
              comp.$root.formData.nicVerificationDRP = "";
            }

            comp.navigateToNextPage();
          } else {
            comp.$buefy.toast.open({
              message: "Failed to capture location from browser",
              type: "is-danger",
            });
          }
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to capture location from browser",
          type: "is-danger",
        });
      }
    },
  },
  mounted: function () {
    // this.updateLastStep();
    this.selectIdProof(this.$root.formData.idProofType);
  },
};
</script>
<style>
.id_box {
  padding: 0px -80% !important;
}

/* Transition classes */

.form-items-move {
  transition: all 0.4s ease;
}
</style>
